<template>
  <main-layout>
    <div class="detailBox" v-if="isShowHtml">
      <div class="bgBox" :style="userDetail.thumb | personBgImageUrl(
              'https://image.manamana.net/assets/pc/cn/person/v2/profile_default_bg.png'
            )">
        <div class="bg"></div>
      </div>
      <div class="contentBox clearfix">
        <div class="leftBox">
          <div class="infoBox">
            <div class="infoLeft">
              <div class="title">{{userDetail.nickname}}{{$t('recruit.招聘')}}</div>
              <div class="name">
                {{detail.positionName}}
                <i>{{detail.negotiable==1?$t('recruit.面议'):detail.salaryBegin+'K-'+detail.salaryEnd+"K"}}</i>
              </div>
              <div
                class="info"
              >{{detail.cityName}} / {{$t('recruit.经验')}}{{getExperience(detail.experience)}} / {{getEducation(detail.education)}} / {{getRecruitNature(detail.recruitNature)}}</div>
              <!-- <div
                class="time"
              >{{detail.auditTime | dateToNow(language)}} {{$t('recruit.发布')}}</div> -->
            </div>
            <div class="infoRight">
              <span class="collected" v-if="detail.collect" @click="getInfo1(2)"><img src="https://image.manamana.net/1658736851000_hGhUDdMr" alt="">已收藏</span
              ><span class="collect" v-else @click="getInfo1(2)"><img src="https://image.manamana.net/1657607061000_QnqWxXXp" alt="">收藏</span
              ><span class="delivery" @click="getInfo1(1)">{{$t('recruit.投简历')}}</span></div>
          </div>
          <div class="describeBox">
            <div class="describe">{{$t('recruit.职位描述')}}</div>
            <div class="text" v-html="getHtml(detail.positionDes)"></div>
          </div>
          <div class="addressBox">
            <div class="address">{{$t('recruit.工作地点')}}</div>
            <div class="addressName">
              <span class="addressDetail" v-html="getHtml1(detail)" @click="gotoSearch(detail.cityId)"></span>
              <span class="fuzhi" @click="copy(1)">{{$t('recruit.复制')}}</span>
            </div>
          </div>
          <div class="company">
            <div class="companyName">{{userDetail.nickname}}{{$t('recruit.介绍')}}</div>
            <div class="companyInfo" v-html="getHtml(companyInfo)"></div>
          </div>
          <div class="imgBox" v-if="companyPhoto.length">
            <div class="imgName">{{$t('recruit.公司相册')}}</div>
            <ul class="clearfix">
              <li v-for="(item, i) in companyPhoto" :key="i" v-if="i < 7" @click="openPhoto(i,1)">
                <img :src="item | imageUrl('', 190, 190)" alt />
                <span v-if="companyPhoto.length > 7 && i == 6">+{{ companyPhoto.length - 7 }}</span>
              </li>
            </ul>
          </div>
          <div class="videoBox" v-if="caseVideo.length || caseImage.length">
            <div class="videoTitle">{{$t('recruit.项目案例')}}</div>
            <div class="videoList">
              <div class="list" v-if="caseVideo.length" v-for="(item,i) in caseVideo" :key="i" @click="gotoVideo(item.path)">
                <div class="imgBox">
                  <img class="img1" :src="item.url | imageUrl('', 1460, 822)" alt />
                  <img class="img2" src="https://image.manamana.net/1646707977000_HpiaAKbp" alt />
                </div>
                <div class="title">{{item.title}}</div>
              </div>
              <div class="list" v-if="caseImage.length" v-for="(item,i) in caseImage" :key="i">
                <div class="imgBox">
                  <img class="img1" :src="item.path | imageUrl('', 1460, 822)" alt  @click="openPhoto(i,2)" />
                </div>
                <div class="title">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightBox">
          <div class="user-fllow">
            <router-link
              target="_blank"
              :class="{ userType2: userDetail.userType === 2 && userDetail.isCertification === 1 }"
              :to="'/peopleCenter/' + userDetail.userId"
            >
              <img
                :src="
                  userDetail.avatar
                    | imageUrl('/static/profile_img_default.png', 160, 160)
                "
                alt
              />
              <h4>{{ userDetail.nickname }}</h4>
            </router-link>
            <p>
              <img src="https://image.manamana.net/1650274642000_wbChnFkI" alt />
              {{ userDetail.area }}
            </p>
            <button
              class="member-focus"
              @mouseenter="isTre3 = true"
              @mouseleave="isTre3 = false"
              v-bind:class="{
                following: userDetail.isFollow,
                'add-follow': !userDetail.isFollow,
              }"
              @click.prevent.stop="Follow(userDetail)"
            >
              {{
              !userDetail.isFollow
              ? $t("global.关注")
              : isTre3
              ? $t("global.取消关注")
              : $t("global.已关注")
              }}
            </button>
          </div>
          <div class="other" v-if="otherList.length">
            <div class="otherTitle clearfix">
              {{$t('recruit.TA的其他招聘')}}
              <i @click="gotoAll">{{$t('recruit.查看全部x个职位',{count: totalRecord + 1})}}</i>
            </div>
            <div class="listBox">
              <div class="li" v-for="(item,i) in otherList" :key="i" @click="changeDetail(item.id)">
                <div class="liTitle">{{item.positionName}}</div>
                <div class="liInfo">
                  <i>{{item.negotiable==1?$t('recruit.面议'):item.salaryBegin+'K-'+item.salaryEnd+"K"}}</i> / {{item.cityName}} / {{$t('recruit.经验')}}{{getExperience(item.experience)}} / {{getEducation(item.education)}} / {{getRecruitNature(item.recruitNature)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="photoBox" v-if="isPhotoBox">
        <div class="pic-container">
          <template v-if="photoList.length > 0">
            <swiper :options="swiperOption" ref="mySwiper" class="home-banner-swiper">
              <!-- slides -->
              <swiper-slide
                v-for="(item, index) of photoList"
                :key="index"
                class="swiper-no-swiping"
                height="100%"
              >
                <span class="videm-img-wrap">
                  <img class="videoImg" :src="item | imageUrl()" alt />
                </span>
              </swiper-slide>
            </swiper>
            <div
              class="swiper-button-prev el-icon-arrow-left"
              @click="prePage"
              v-if="photoList.length != 1"
            ></div>
            <div
              class="swiper-button-next el-icon-arrow-right"
              @click="nextPage"
              v-if="photoList.length != 1"
            ></div>
            <div class="close" @click="isPhotoBox = false">
              <img src="/static/video/photo_close_btn.png" alt />
            </div>
            <div class="page">{{ pageIndex }}/{{ photoList.length }}</div>
          </template>
        </div>
      </div>
      <div class="topBox" v-if="isShowTop">
        <div class="topDetail clearfix">
          <div class="topLeftBox">
            <div class="topTitle">
              {{detail.positionName}}
              <i>{{detail.negotiable==1?$t('recruit.面议'):detail.salaryBegin+'K-'+detail.salaryEnd+"K"}}</i>
            </div>
            <div
              class="topInfo"
            >{{detail.cityName}} / {{$t('recruit.经验')}}{{getExperience(detail.experience)}} / {{getEducation(detail.education)}} / {{getRecruitNature(detail.recruitNature)}}</div>
            <div class="topSee" @click="gotoAll">{{$t('recruit.查看该公司所有职位')}} ></div>
          </div>
          <div class="topTou"><span class="collected" v-if="detail.collect" @click="getInfo1(2)"><img src="https://image.manamana.net/1658736851000_hGhUDdMr" alt="">已收藏</span
              ><span class="collect" v-else @click="getInfo1(2)"><img src="https://image.manamana.net/1657607061000_QnqWxXXp" alt="">收藏</span
              ><span class="delivery" @click="getInfo1(1)">{{$t('recruit.投简历')}}</span></div>
        </div>
      </div>
      <div class="popBox" v-if="popShow">
        <div class="box">
          <div class="title">
            {{this.popShow3?'选择要投递的文件':$t('recruit.投简历')}}
            <span @click="close"></span>
          </div>
          <div class="content" v-if="popShow1">
            <div class="name">{{uploadType == 1 ? $t('recruit.请上传附件简历') : '请上传作品集附件'}}</div>
            <div class="text">{{$t('recruit.简历仅支持Word、PDF、PPT格式的文件，文件大小需小于10M；如您需要投递作品集，可在上传简历附件后填写作品集链接')}}</div>
            <div class="but" @click="uploadFile">{{uploadType == 1 ? $t('recruit.上传附件简历') : '上传作品集附件'}}</div>
          </div>
          <div class="content" v-if="popShow4">
            <div class="text1">您的在线简历尚未完成</div>
            <div class="text2">请完善后再投递</div>
            <div class="but" @click="gotoResume">完善简历</div>
          </div>
          <div class="content" v-if="popShow2">
            <img class="img1" src="https://image.manamana.net/1652418599000_TZCUgbko" alt />
            <div class="uploadNumber">{{proNumber}}</div>
            <div class="uploadName">{{fileName}}</div>
            <div class="progress">
              <span style="width: 0%;" ref="progress"></span>
            </div>
          </div>
          <div class="content content1" v-if="popShow3">
            <div class="resumeBox">
              <div class="fileBox fileBox2 clearfix">
                <span @click="selectFile(1)" :class="[fileType == 1?'active':'']"></span>
                <img @click="selectFile(1)" class="img2" src="https://image.manamana.net/1657766884000_dSBgoPdM" alt="">
                <div @click="selectFile(1)" class="nameBox">
                  <p class="name1">在线简历</p>
                </div>
                <div class="boxBut"><i @click="gotoPreviewResume">预览</i><i @click="changeResume">修改</i></div>
              </div>
              <div class="fileBox clearfix">
                <span @click="selectFile(2)" :class="[fileType == 2?'active':'']"></span>
                <img @click="selectFile(2)" class="img2" src="https://image.manamana.net/1657766898000_smyOYBYP" alt="">
                <div @click="selectFile(2)" class="nameBox">
                  <p class="name1">附件简历</p>
                  <p class="name2">{{resumeFile?resumeFile.name:'尚未上传'}}</p>
                </div>
                <div class="boxBut" @click="uploadFile1(1)"><i>{{resumeFile?'预览':'去上传'}}</i></div>
              </div>
            </div>
            <div class="fileBox fileBox1 clearfix">
                <img @click="changeCheck" class="img3" :src="check?'https://image.manamana.net/1657769421000_CzTunSrl':'https://image.manamana.net/1657768999000_uxOGEgfv'" alt="">
                <img @click="changeCheck" class="img2" src="https://image.manamana.net/1657766994000_BtxpieDc" alt="">
                <div @click="changeCheck" class="nameBox">
                  <p class="name1">作品集附件</p>
                  <p class="name2">{{videoFile?videoFile.name:'尚未上传'}}</p>
                </div>
                <div class="boxBut" @click="uploadFile1(2)"><i>{{videoFile?'预览':'去上传'}}</i></div>
              </div>
            <div class="but" @click="butUpload">{{$t('recruit.投简历')}}</div>
          </div>
        </div>
      </div>
      <input type="file" style="display: none" class="upInputSure" @change="upVideo" accept=".doc,.docx,.ppt,.pptx,.pdf" />
    </div>
  </main-layout>
</template>
<script>
import MainLayout from "@/layouts/MainLayout";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import * as qiniu from "qiniu-js";
export default {
  name: "releasePosition",
  metaInfo() {
    return {
      title: "MANA " + this.$t("global.招聘")
    };
  },
  data() {
    return {
      companyName: null,
      companyInfo: null,
      companyPhoto: [],
      caseVideo: [],
      caseImage: [],
      isPhotoBox: false,
      swiperOption: {
        autoplay: false,
        noSwiping: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      pageIndex: 0,
      detail: {},
      userDetail: {},
      isShowTop: false,
      popShow: false,
      popShow1: false,
      popShow2: false,
      popShow3: false,
      popShow4: false,
      fileName: "",
      key: null,
      link: null,
      proNumber: "",
      otherList: [],
      totalRecord: 0,
      photoList: [],
      isShowHtml: false,
      resumeFile: null,
      videoFile: null,
      fileType: 1,
      check: false,
      uploadType: null,
    };
  },
  components: {
    MainLayout,
    swiper,
    swiperSlide
  },
  created() {
    this.buriedPoint(25, this.$route.params.id);
    this.getInfo();
  },
  mounted() {
    window.addEventListener("scroll", this.showTop, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.showTop);
  },
  methods: {
    getInfo1(index) {
      let auth_token = localStorage.getItem("auth_token");
      if (auth_token) {
        this.$http.get("/api/customer/info/get").then((response) => {
          if (response.code !== "ServiceError") {
            if (
              response.data.userType === 2 &&
              response.data.isCertification === 1
            ) {
              if (index == 1) {
                this.$message({
                  type: 'info',
                  message: '请切换到个人账号后投递简历',
                })
              }
              if (index == 2) {
                this.$message({
                  type: 'info',
                  message: '请切换到个人账号后收藏职位',
                })
              }
            } else {
              if (index == 1) {
                this.delivery()
              }
              if (index == 2) {
                this.collectRecruit()
              }
            }
          } else {
            this.loginout();
          }
        });
      } else {
        this.loginout();
      }
    },
    loginout() {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userId");
      this.$store.dispatch("restUser");
      localStorage.setItem("isLogin", "false");
      this.$router.push(`/login?redirecturl=${window.location.href}`);
    },
    butUpload() {
      var params = {
        sendOnlineResume: this.fileType == 1 ? 1 : 0,
        linkPath: this.check ? this.videoFile.path : null,
        recruitId: this.$route.params.id,
        resumeName: this.fileType == 2 ? this.resumeFile.name : null,
        resumePath: this.fileType == 2 ? this.resumeFile.path : null
      }
      this.$http.post("/api/u/recruit/resume/online/send/online", params, {
          headers: {
            "Content-Type": "application/json"
          }
        }).then((res)=>{
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.close();
          }
      })
    },
    gotoPreviewResume() {
      let routeData = this.$router.resolve({
        path: "/previewResume/" + this.peopleMessage.userId
      });
      window.open(routeData.href, "_blank");
    },
    changeResume() {
      let routeData = this.$router.resolve({
        path: "/MyResume"
      });
      window.open(routeData.href, "_blank");
    },
    uploadFile1(type) {
      if (type == 1) {
        if (this.resumeFile) {
          //预览
          window.open('https://file.manamana.net/' + this.resumeFile.path, "_blank");
          return
        }
      }
      if (type == 2) {
        if (this.videoFile) {
          //预览
          window.open('https://file.manamana.net/' + this.videoFile.path, "_blank");
          return
        }
      }
      this.uploadType = type;
      this.popShow3 = false;
      this.popShow1 = true;
    },
    selectFile(type) {
      if (type == 2 && !this.resumeFile) {
        this.$message.error("请先上传附件简历！")
        return
      }
      this.fileType = type;
    },
    changeCheck() {
      if (!this.videoFile) {
        this.$message.error("请先上传作品集附件！")
        return
      }
      this.check = !this.check;
    },
    collectRecruit() {
      if (this.detail.collect) {
        this.$http
          .get("/api/u/recruit/collect/cancel/" + this.$route.params.id)
          .then(res => {
            if (res.code == "OK") {
              this.detail.collect = false;
              this.$message.success(res.message);
            }
          });
      } else {
        this.$http
          .get("/api/u/recruit/collect/" + this.$route.params.id)
          .then(res => {
            if (res.code == "OK") {
              this.detail.collect = true;
              this.$message.success(res.message);
            }
          });
      }
    },
    gotoSearch(id) {
      let routeData = this.$router.resolve({
        path: "/jobs/home?type=1&cityId=" + id
      });
      window.open(routeData.href, "_blank");
    },
    gotoVideo(id) {
      let routeData = this.$router.resolve({
        path: "/video/detail?id=" + id
      });
      window.open(routeData.href, "_blank");
    },
    gotoResume() {
      let routeData = this.$router.resolve({
        path: "/MyResume"
      });
      window.open(routeData.href, "_blank");
    },
    getHtml(text) {
      let value = "";
      if (text) {
        value = text.replace(/(\r\n|\n|\r)/gm, "<br />");
      }
      return value;
    },
    getHtml1(detail) {
      let value = "";
      if (detail && detail.allAddressName && detail.cityName) {
        value = detail.allAddressName.replace(
          detail.cityName,
          ' <i style="color: #2026CC;">' + detail.cityName + "</i>"
        );
      }
      return value;
    },
    changeDetail(id) {
      this.$router.push("/recruitDetail/" + id);
      this.getInfo();
    },
    getOtherList(id) {
      this.$http
        .get("/api/recruit/info/" + id + "/" + this.$route.params.id)
        .then(res => {
          if (res.code == "OK") {
            this.otherList = res.data.list;
            this.totalRecord = res.data.totalRecord;
            this.isShowHtml = true;
          }
        });
    },
    close() {
      this.popShow = false;
      this.popShow1 = false;
      this.popShow2 = false;
      this.popShow3 = false;
      this.popShow4 = false;
    },
    delivery() {
      this.$http
        .get("/api/u/recruit/resume/online/info/resume/check")
        .then(res => {
          if (res.code == "OK") {
            if (res.data.isOk == 1) {
              //简历已完善
              this.popShow = true;
              this.popShow3 = true;
              this.getFileList();
            } else {
              //简历未完善
              this.popShow = true;
              this.popShow4 = true;
            }
          }
        });
    },
    uploadFileKey() {
      var params = {
        name: this.fileName,
        path: this.key,
        type: this.uploadType
      };
      this.$http.post("/api/u/recruit/resume/online/info/file", params, {
          headers: {
            "Content-Type": "application/json"
          }
        }).then((res)=>{
          if (res.code == "OK") {
            this.$message.success(res.message);
            this.getFileList();
          }
        })
    },
    getFileList() {
      this.$http.get("/api/u/recruit/resume/online/info/file").then(resp => {
        if (resp.code == "OK") {
          this.resumeFile = null;
          this.videoFile = null;
          if (resp.data.length) {
            for (let i = 0; i < resp.data.length; i++) {
              if (resp.data[i].type == 1) {
                this.resumeFile = resp.data[i];
              }
              if (resp.data[i].type == 2) {
                this.videoFile = resp.data[i];
              }
            }
          }
        }
      });
    },
    upVideo(e) {
      var $this = this;
      var fileName = e.target.files[0].name;
      const type = e.target.files[0].type;
      // const list =
      //   "video/quicktime,video/x-flv,video/mpg,video/mpeg,video/x-msvideo,video/x-ms-wmv,video/x-ms-asf,	application/vnd.rn-realmedia,video/rmvb,video/mkv,video/mp4".split(
      //     ","
      //   );
      // if (!list.includes(type)) {
      //   this.$message.info(`${$this.$t("global.上传失败")},${this.$t(
      //     "global.请检查上传格式是否符合支持格式"
      //   )}`);
      //   return;
      // }
      if (e.target.files[0].size / 1024 / 1024 > 10) {
        this.$message.info(this.$t("works.文件不能大于10M"));
        return;
      }

      var observable;
      var subscription;
      var error = function(err) {
        $this.$message.error($this.$t("global.上传失败"));
      };

      var complete = function(res) {
        $this.key = res.key;
        $this.popShow2 = false;
        $this.popShow3 = true;
        $this.uploadFileKey();
      };

      var next = function(response) {
        var total = response.total;
        $this.popShow1 = false;
        $this.popShow2 = true;
        $this.fileName = e.target.files[0].name;
        $this.$refs.progress.style.width = parseInt(total.percent) + "%";
        $this.proNumber = `${$this.$t("recruit.正在上传")}${parseInt(
          total.percent
        )}%`;
        // $this.$refs.proNumber.innerHTML = `${$this.$t("recruit.正在上传")}${
        //       Math.round(total.percent * 100) / 100
        //     }%`;
      };
      var subObject = {
        next: next,
        error: error,
        complete: complete
      };

      var config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 3,
        region: null
      };
      var putExtra = {
        fname: fileName.split(".")[0],
        params: {},
        mimeType: null
      };
      this.$http.get("/api/common/upload/token/file").then(res => {
        this.token = res.data;
        observable = qiniu.upload(
          e.target.files[0],
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          this.token,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
    },
    uploadFile() {
      document.querySelector(".upInputSure").value = "";
      document.querySelector(".upInputSure").click();
    },
    gotoAll() {
      let routeData = this.$router.resolve({
        path:
          "/peopleCenter/" + this.detail.userId + "/recruit"
      });
      window.open(routeData.href, "_blank");
    },
    showTop() {
      var scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scroll > 294) {
        this.isShowTop = true;
      } else {
        this.isShowTop = false;
      }
    },
    Follow(item) {
      const url = `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
        item.userId
      }`;
      this.$http.post(url).then(res => {
        if (res.code === "OK") {
          item.isFollow = !item.isFollow;
        }
      });
    },
    copy(index) {
      if (index == 1) {
        var copyInput = document.createElement("input");
        copyInput.setAttribute("value", this.detail.allAddressName);
        document.body.appendChild(copyInput);
        copyInput.select();
        document.execCommand("copy");
        document.body.removeChild(copyInput);
        this.$message.success(this.$t("global.已复制"));
      }
      if (index == 2) {
        var copyInput = document.createElement("input");
        copyInput.setAttribute("value", this.detail.recruitEmail);
        document.body.appendChild(copyInput);
        copyInput.select();
        document.execCommand("copy");
        document.body.removeChild(copyInput);
        this.$message.success(this.$t("global.已复制"));
      }
    },
    getInfo() {
      this.$http
        .get("/api/recruit/info/detail/" + this.$route.params.id)
        .then(res => {
          if (res.code == "OK") {
            this.getUserDetail(res.data.userId);
            this.getOtherList(res.data.userId);
            this.detail = res.data;
            this.companyName = res.data.companyInfoDomain.companyName;
            this.companyInfo = res.data.companyInfoDomain.companyInfo;
            if (res.data.companyInfoDomain.companyPhoto !== "") {
              this.companyPhoto = res.data.companyInfoDomain.companyPhoto.split(
                ","
              );
            }
            if (res.data.companyInfoDomain.caseVideo) {
              this.caseVideo = JSON.parse(res.data.companyInfoDomain.caseVideo);
            }
            if (res.data.companyInfoDomain.caseImage) {
              this.caseImage = JSON.parse(res.data.companyInfoDomain.caseImage);
            }
          }
        });
    },
    getUserDetail(id) {
      this.$http
        .get("/api/mobile/u/getInfo?userId=" + id + "&type=1")
        .then(res => {
          if (res.code == "OK") {
            this.userDetail = res.data;
          }
        });
    },
    openPhoto(i, type) {
      this.photoList = [];
      if (type == 1) {
        this.photoList = this.companyPhoto;
      }
      if (type == 2) {
        for (let i = 0; i < this.caseImage.length; i++) {
          this.photoList.push(this.caseImage[i].path);
        }
      }
      this.pageIndex = i + 1;
      this.isPhotoBox = true;
      this.$nextTick(() => {
        if (this.photoList.length > 7 && i == 7) {
          this.$refs.mySwiper.swiper.slideTo(0);
        }
        this.$refs.mySwiper.swiper.slideTo(i);
      });
    },
    prePage() {
      if (this.pageIndex > 1) {
        this.pageIndex--;
      }
      return;
    },
    nextPage() {
      if (this.pageIndex < this.companyPhoto.length) {
        this.pageIndex++;
      }
      return;
    },
    getExperience(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.1年以下");
      }
      if (i == 3) {
        return this.$t("recruit.1-3年");
      }
      if (i == 4) {
        return this.$t("recruit.3-5年");
      }
      if (i == 5) {
        return this.$t("recruit.5-10年");
      }
      if (i == 6) {
        return this.$t("recruit.10年以上");
      }
    },
    getEducation(i) {
      if (i == 1) {
        return this.$t("recruit.不限");
      }
      if (i == 2) {
        return this.$t("recruit.大专");
      }
      if (i == 3) {
        return this.$t("recruit.本科");
      }
      if (i == 4) {
        return this.$t("recruit.硕士");
      }
      if (i == 5) {
        return this.$t("recruit.博士");
      }
    },
    getRecruitNature(i) {
      if (i == 1) {
        return this.$t("recruit.全职");
      }
      if (i == 2) {
        return this.$t("recruit.实习生");
      }
      if (i == 3) {
        return this.$t("recruit.校招");
      }
      if (i == 4) {
        return this.$t("recruit.兼职");
      }
    }
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    }
  }
};
</script>
<style lang="stylus" scoped>
.detailBox {
  min-height: 100vh; 
  .bgBox {
    width: 100%;
    min-width: 1110px;
    height: 250px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    .bg {
      height: 250px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    }
  }

  .contentBox {
    margin: -80px auto 0;
    width: 1110px;

    .leftBox {
      float: left;
      width: 753px;
      padding-bottom: 50px;
      .infoBox {
        position: relative;

        .infoLeft {
          width: 600px;

          .title {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 18px;
          }

          .name {
            font-size: 24px;
            font-weight: 600;
            color: #0A0A0A;
            line-height: 33px;
            margin: 10px 0;

            i {
              font-size: 20px;
              font-weight: 600;
              color: #FC703E;
              margin-left: 65px;
            }
          }

          .info {
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
          }

          .time {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            margin-top: 10px;
          }
        }

        .infoRight {
          position: absolute;
          right: 0;
          bottom: 26px;
          .collect{
            display: inline-block;
            width: 126px;
            height: 44px;
            border: 1px solid #2026CC;
            vertical-align: middle;
            box-sizing: border-box;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
            margin-right: 10px;
            font-size: 16px;
            font-weight: 600;
            color: #2026CC;
            img{
              width: 24px;
              height: 24px;
              margin-right: 2px;
              margin-bottom: 3px;
            }
          }
          .collected{
            width: 126px;
            height: 44px;
            background: #2026CC;
            line-height: 44px;
            display: inline-block;
            text-align: center;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            vertical-align: middle;
            margin-right: 10px;
            img{
              width: 24px;
              height: 24px;
              margin-right: 2px;
              margin-bottom: 3px;
            }
          }
          .delivery{
            width: 120px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
            background: #2026CC;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }

      .describeBox {
        margin-top: 30px;

        .describe {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 20px;
        }

        .text {
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
        }
      }

      .addressBox {
        margin-top: 40px;

        .address {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 20px;
        }

        .addressName {
          color: #666;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;

          .addressDetail {
            cursor: pointer;
          }

          .fuzhi {
            color: #2026CC;
            cursor: pointer;
            margin-left: 20px;
          }
        }
      }

      .emailBox {
        margin-top: 40px;

        .email {
          font-size: 14px;
          color: #333;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 20px;
        }

        .title1 {
          color: #666;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;

          span {
            color: #2026CC;
          }

          i {
            color: #2026CC;
            cursor: pointer;
            margin-left: 20px;
          }
        }

        .title2 {
          color: #666;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
        }
      }

      .company {
        margin-top: 40px;

        .companyName {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 20px;
        }

        .companyInfo {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }
      }

      .imgBox {
        margin-top: 40px;

        .imgName {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin-bottom: 20px;
          line-height: 20px;
        }

        ul {
          li {
            width: 95px;
            height: 95px;
            float: left;
            margin-right: 10px;
            position: relative;
            cursor: pointer;

            &:last-child {
              margin-right: 0;
            }

            img {
              width: 95px;
              height: 95px;
            }

            span {
              position: absolute;
              text-align: center;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              font-size: 20px;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              background: rgba(10, 10, 10, 0.69);
              line-height: 95px;
            }
          }
        }
      }

      .videoBox {
        margin-top: 40px;

        .videoTitle {
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin-bottom: 20px;
          line-height: 20px;
        }

        .videoList {
          .list {
            margin-bottom: 30px;
            cursor: pointer;

            .imgBox {
              width: 730px;
              height: 410px;
              position: relative;

              .img1 {
                width: 730px;
                height: 410px;
              }

              .img2 {
                position: absolute;
                width: 54px;
                height: 70px;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }

            .title {
              margin-top: 10px;
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              line-height: 20px;
            }
          }
        }
      }
    }

    .rightBox {
      width: 285px;
      float: right;

      .user-fllow {
        width: 285px;
        height: 270px;
        background: #fff;
        border: 1px solid #EBEBEB;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 30px;
        box-sizing: border-box;

        a {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 100%;

          &.userType2::before {
            content: '';
            right: calc(50% - 36px);
            top: 60px;
            position: absolute;
            width: 16px;
            height: 16px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 16px;
          }

          img {
            width: 80px;
            height: 80px;
            border-radius: 40px;
            border: 1px solid #f5f5f5;
          }

          h4 {
            color: #333333;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            padding: 15px 0 5px;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        p {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          margin-bottom: 30px;

          img {
            width: 10px;
            height: 13px;
            margin-right: 4px;
          }
        }

        .member-focus {
          width: 90px;
          height: 30px;
          padding: 5px 0;
          background: #2026CC;
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;

          &:hover {
            background: rgba(28, 33, 176, 1);
          }

          &.add-follow::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('/static/v2/channel_follow_btn_plus.png');
            background-size: 12px;
            margin-right: 3px;
            vertical-align: middle;
            margin-top: -2px;
          }

          &.following {
            background: #fff;
            border: 1px solid #b8b8b8;
            color: #b8b8b8;
          }
        }
      }

      .other {
        margin-top: 40px;

        .otherTitle {
          height: 25px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 25px;

          i {
            float: right;
            font-size: 12px;
            font-weight: 500;
            color: #2026CC;
            cursor: pointer;
          }
        }

        .listBox {
          margin-top: 30px;

          .li {
            margin-bottom: 20px;
            cursor: pointer;
            .liTitle {
              height: 20px;
              font-size: 14px;
              font-weight: 600;
              color: #0A0A0A;
              line-height: 20px;
              margin-bottom: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .liInfo {
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999;
              line-height: 17px;

              i {
                color: #FC703E;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }

  .photoBox {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.85);
    padding: 136px 0 70px 0;
    box-sizing: border-box;

    .close {
      position: absolute;
      top: 70px;
      right: 85px;
      width: 44px;
      height: 44px;
      cursor: pointer;
      z-index: 999999;

      img {
        width: 44px;
        height: 44px;
      }
    }

    .page {
      position: absolute;
      bottom: 25px;
      left: 50%;
      width: 40px;
      margin-left: -20px;
      font-size: 20px;
      color: #999999;
      text-align: center;
    }

    .pic-container {
      width: calc(100vw - 298px);
      margin: 0 auto;
      overflow: hidden;
      zoom: 1;
      height: 100%;
    }

    .swiper-container {
      height: 100%;
    }

    .swiper-button-prev {
      background: none;
      font-size: 0.5rem;
      color: #fff;
      z-index: 1011;
      left: 85px;
      top: 50%;
      width: 44px;
      height: 44px;
      margin-top: -22px;
    }

    .swiper-button-next {
      background: none;
      font-size: 0.5rem;
      color: #fff;
      z-index: 1011;
      right: 85px;
      top: 50%;
      width: 44px;
      height: 44px;
      margin-top: -22px;
    }

    .swiper-slide {
      display: table;
    }

    .videm-img-wrap {
      display: table-cell;
      vertical-align: middle;
      height: calc(100vh - 140px);
    }

    .videoImg {
      display: block;
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
  }

  .topBox {
    background-image: url('https://image.manamana.net/1650275694000_hgFrkehy');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    min-width: 1110px;
    width: 100%;
    height: 134px;
    position: fixed;
    top: 66px;
    left: 0;

    .topDetail {
      width: 1110px;
      margin: 20px auto 0;

      .topLeftBox {
        float: left;

        .topTitle {
          height: 33px;
          font-size: 24px;
          font-weight: 600;
          color: #0A0A0A;
          line-height: 33px;

          i {
            font-size: 20px;
            font-weight: 600;
            color: #FC703E;
            margin-left: 63px;
          }
        }

        .topInfo {
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          margin: 10px 0;
        }

        .topSee {
          height: 17px;
          font-size: 12px;
          font-weight: 600;
          color: #2026CC;
          line-height: 17px;
          cursor: pointer;
        }
      }

      .topTou {
        float: right;
        margin-right: 355px;
        margin-top: 27px;
        .collect{
            display: inline-block;
            width: 126px;
            height: 44px;
            border: 1px solid #2026CC;
            vertical-align: middle;
            box-sizing: border-box;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
            margin-right: 10px;
            font-size: 16px;
            font-weight: 600;
            color: #2026CC;
            img{
              width: 24px;
              height: 24px;
              margin-right: 2px;
              margin-bottom: 3px;
            }
          }
          .collected{
            width: 126px;
            height: 44px;
            background: #2026CC;
            line-height: 44px;
            display: inline-block;
            text-align: center;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            vertical-align: middle;
            margin-right: 10px;
            img{
              width: 24px;
              height: 24px;
              margin-right: 2px;
              margin-bottom: 3px;
            }
          }
          .delivery{
            width: 120px;
            height: 44px;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
            background: #2026CC;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            display: inline-block;
            vertical-align: middle;
          }
      }
    }
  }

  .popBox {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 111;

    .box {
      width: 540px;
      padding-bottom: 50px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);

      .title {
        text-align: center;
        height: 52px;
        line-height: 52px;
        border-bottom: 1px solid #e0e0e0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        position: relative;

        span {
          position: absolute;
          color: #999;
          right: 24px;
          top: 20px;
          width: 13px;
          height: 13px;
          cursor: pointer;
          background: url('/static/uploadvideo/close_btn@2x.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .content {
        text-align: center;
        padding: 0 58px;
        .resumeBox{
          border-bottom: 1px solid #E0E0E0;
          padding: 20px;
        }
        .fileBox{
            span{
              float: left;
              width: 18px;
              height: 18px;
              border: 2px solid #CDCDCD;
              margin-right: 20px;
              border-radius: 50%;
              margin-top: 11px;
              box-sizing: border-box;
              cursor: pointer;
            }
            span.active{
              border: 5px solid #2026CC;
            }
            .img3{
              float: left;
              width: 18px;
              height: 18px;
              margin-right: 20px;
              margin-top: 11px;
              cursor: pointer;
            }
            .img2{
              width: 30px;
              height: 40px;
              float: left;
              margin-right: 10px;
              cursor: pointer;
            }
            .nameBox{
              float: left;
              cursor: pointer;
              .name1{
                height: 20px;
                font-size: 14px;
                font-weight: 600;
                color: #666666;
                line-height: 20px;
                margin-bottom: 2px;
                text-align: left;
              }
              .name2{
                height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
                line-height: 18px;
                text-align: left;
              }
            }
            .boxBut{
              float: right;
              margin-top: 11px;
              height: 18px;
              line-height: 18px;
              i{
                font-size: 13px;
                font-weight: 400;
                color: #2026CC;
                margin-left: 15px;
                cursor: pointer;
              }
            }
          }
          .fileBox1{
            padding: 20px;
            margin-bottom: 20px;
          }
          .fileBox2{
            margin-bottom: 34px;
          }
        .name {
          height: 28px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-top: 28px;
        }

        .text {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          margin: 20px 0 40px 0;
        }
        .text1{
          margin-top: 30px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          text-align: center;
        }
        .text2{
          margin-bottom: 40px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          text-align: center;
        }
        .but {
          width: 118px;
          height: 34px;
          line-height: 34px;
          background: #2026CC;
          font-size: 14px;
          font-weight: 600;
          color: #FFFFFF;
          margin: 0 auto;
          cursor: pointer;
        }

        .img1 {
          width: 120px;
          height: 120px;
          margin-top: 28px;
        }

        .uploadNumber {
          height: 24px;
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin: 20px 0 5px 0;
        }

        .uploadName {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          margin-bottom: 26px;
        }

        .progress {
          width: 175px;
          height: 4px;
          background: #DDDDDD;
          position: relative;
          margin: 0 auto;

          span {
            position: absolute;
            left: 0;
            top: 0;
            height: 4px;
            background: #2026CC;
            width: 5%;
          }
        }

        .fileName {
          margin-top: 28px;
          text-align: left;

          .img2 {
            width: 30px;
            height: 40px;
            vertical-align: bottom;
            margin-right: 10px;
          }

          span {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            display: inline-block;
            width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          i {
            font-size: 12px;
            font-weight: 400;
            color: #2026CC;
            float: right;
            cursor: pointer;
            line-height: 17px;
            margin-top: 23px;
          }
        }

        .link {
          margin: 20px 0;
          text-align: left;

          .linkTitle {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            margin-bottom: 5px;
          }

          input {
            border-bottom: 1px solid #DDDDDD;
            height: 30px;
            line-height: 30px;
            width: 100%;
          }
        }

        .info {
          font-size: 12px;
          font-weight: 300;
          color: #999999;
          line-height: 17px;
          margin-bottom: 40px;
          text-align: left;
        }
      }
      .content1{
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/recruitDetail.vue